import React from "react";
import "./Footer.css";

function Footer() {
  const d = new Date();
  let year = d.getFullYear();

  return (
    <div className="copyright-div">
      <p className="copyright-para">
        Copyright ©{year} All rights reserved | Made with
        <span className="footer-love-icon"> ❤ </span> by <a className="footer-href" target="_blank" rel="noopener noreferrer" href="https://github.com/abhijeetvinkare">Abhijeet_Vinkare</a> 
      </p>
    </div>
  );
}

export default Footer;
